import { Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';

const SentBadge = ({ verified }: { verified: string }) => {
  if (!verified) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: '#65BBA9',
        color: 'white',
        borderRadius: '5px',
        textAlign: 'center',
        fontWeight: 'normal',
        marginLeft: '10px',
        width: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px',
        height: '16px',
        cursor: 'default',
      }}
    >
      <Tooltip placement="top" title={format(verified, 'yyyy-MM-dd HH:mm:ss')}>
        <Typography style={{ fontWeight: 'bold', fontSize: '9px' }}>SENT</Typography>
      </Tooltip>
    </div>
  );
};

export default SentBadge;
